<template>
  <div class="p-3">
    <div class="premium-card shadow-sm">
      <div class="card-header-premium d-flex justify-content-between align-items-center">
        <span><i class="fa fa-link mr-2"></i> NF-E REFERENCIADAS</span>
        <b-button 
          variant="light" 
          class="rounded-pill px-3 shadow-sm text-primary font-weight-bold"
          @click="abrirModalIncluir"
          :disabled="!podeEditar"
        >
          <i class="fa fa-plus mr-1"></i> Incluir Referência
        </b-button>
      </div>

      <div class="p-0">
        <b-table
          class="premium-table mb-0"
          :items="referenciadas"
          :fields="fields"
          :busy="loading"
          show-empty
          empty-text="Não há notas referenciadas"
          hover
          responsive
        >
          <template #cell(TX_NUM_CHAVE_ACESSO_NFE)="data">
            <span class="text-monospace small">{{ data.value }}</span>
          </template>
          <template #cell(acoes)="data">
            <b-button
              size="sm"
              variant="outline-warning"
              class="rounded-pill px-3 mr-1"
              @click="abrirModalAlterar(data.item)"
              :disabled="!podeEditar"
              title="Alterar"
            >
              <i class="fa fa-pencil"></i>
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              class="rounded-pill px-3"
              @click="excluir(data.item)"
              :disabled="!podeEditar"
              title="Excluir"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>

    <!-- Modal de Inclusão/Alteração -->
    <b-modal
      ref="modalReferenciada"
      hide-header
      hide-footer
      centered
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      @hidden="limparForm"
    >
      <!-- Custom Premium Header -->
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
        <div class="header-icon-wrapper-modal mr-3 bg-white-100">
          <i class="fa fa-link text-primary"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">{{ modalTitulo }}</h5>
          <small class="text-white opacity-75">Vincule outras notas fiscais a este documento</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalReferenciada.hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4">
        <b-form @submit.prevent="salvar">
          <fieldset :disabled="!podeEditar" class="border-0 p-0 m-0">
          <div class="modal-section-title mb-3">
            <i class="fa fa-info-circle mr-2 text-primary"></i> Dados da Referência
          </div>

          <b-form-group label="* Chave de Acesso da NF-e Referenciada" label-class="modal-label-premium">
            <b-form-input
              v-model="form.TX_NUM_CHAVE_ACESSO_NFE"
              maxlength="44"
              placeholder="Digite a chave de acesso (44 dígitos)"
              class="rounded-pill shadow-xs border-0 bg-light p-3"
              required
            />
            <small class="text-muted mt-1 d-block">
              A chave de acesso deve conter exatamente 44 caracteres numéricos.
            </small>
          </b-form-group>
          </fieldset>

          <!-- Rodapé Premium -->
          <div class="modal-footer-premium p-3 bg-light d-flex justify-content-end border-top mx-n4 mb-n4 mt-4">
            <b-button variant="light" @click="$refs.modalReferenciada.hide()" class="mr-2 rounded-pill px-4 shadow-sm font-weight-bold">
              <i class="fa fa-times mr-1"></i> {{ podeEditar ? 'Cancelar' : 'Fechar' }}
            </b-button>
            <b-button v-if="podeEditar" variant="primary" @click="salvar" class="rounded-pill px-4 shadow-sm font-weight-bold">
              <i class="fa fa-check mr-1"></i> Gravar Referência
            </b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'NfeAbaNfeReferenciada',
  props: {
    nfe: { type: Object, required: true },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      referenciadas: [],
      loading: false,
      form: {
        ID: null,
        ID_NFE: null,
        TX_NUM_CHAVE_ACESSO_NFE: ''
      },
      modoEdicao: false,
      fields: [
        { key: 'TX_NUM_CHAVE_ACESSO_NFE', label: 'Chave de Acesso', sortable: true },
        { key: 'acoes', label: 'Ações', class: 'text-center' }
      ]
    }
  },
  computed: {
    modalTitulo() {
      return this.modoEdicao ? 'Alterar Nota Referenciada' : 'Incluir Nota Referenciada'
    }
  },
  watch: {
    'nfe.ID': {
      handler(newVal) {
        if (newVal) {
          this.carregarReferenciadas()
        }
      },
      immediate: true
    }
  },
  methods: {
    async carregarReferenciadas() {
      if (!this.nfe.ID) return

      try {
        this.loading = true
        const { data } = await this.$http.get(`/api/protected/notaFiscal/referenciada/getByNfeId/${this.nfe.ID}`)
        this.referenciadas = Array.isArray(data) ? data : []
      } catch (err) {
        console.error('Erro ao carregar notas referenciadas:', err)
        this.$bvToast.toast('Erro ao carregar notas referenciadas', { variant: 'warning', solid: true })
        this.referenciadas = []
      } finally {
        this.loading = false
      }
    },

    abrirModalIncluir() {
      this.modoEdicao = false
      this.limparForm()
      this.$refs.modalReferenciada.show()
    },

    async abrirModalAlterar(item) {
      try {
        this.modoEdicao = true
        const { data } = await this.$http.get(`/api/protected/notaFiscal/referenciada/getById/${item.ID}`)
        const registro = Array.isArray(data) ? data[0] : data
        
        this.form.ID = registro.ID
        this.form.ID_NFE = registro.ID_NFE
        this.form.TX_NUM_CHAVE_ACESSO_NFE = registro.TX_NUM_CHAVE_ACESSO_NFE || ''
        
        this.$refs.modalReferenciada.show()
      } catch (err) {
        console.error('Erro ao carregar nota referenciada:', err)
        this.$bvToast.toast('Erro ao carregar nota referenciada', { variant: 'danger', solid: true })
      }
    },

    async salvar(bvModalEvent) {
      bvModalEvent.preventDefault()

      // Validação
      if (!this.form.TX_NUM_CHAVE_ACESSO_NFE || this.form.TX_NUM_CHAVE_ACESSO_NFE.trim().length === 0) {
        this.$bvToast.toast('Informe a chave de acesso da NF-e referenciada', { variant: 'warning', solid: true })
        return
      }

      if (this.form.TX_NUM_CHAVE_ACESSO_NFE.trim().length !== 44) {
        this.$bvToast.toast('A chave de acesso deve conter 44 dígitos', { variant: 'warning', solid: true })
        return
      }

      try {
        const payload = {
          ID: this.form.ID,
          ID_NFE: this.nfe.ID,
          TX_NUM_CHAVE_ACESSO_NFE: this.form.TX_NUM_CHAVE_ACESSO_NFE.trim()
        }

        const endpoint = this.modoEdicao 
          ? '/api/protected/notaFiscal/referenciada/edit'
          : '/api/protected/notaFiscal/referenciada/post'

        await this.$http.post(endpoint, {referenciada: payload})

        this.$bvToast.toast(
          this.modoEdicao ? 'Nota referenciada alterada com sucesso!' : 'Nota referenciada incluída com sucesso!',
          { variant: 'success', solid: true }
        )

        await this.carregarReferenciadas()
        this.$refs.modalReferenciada.hide()

      } catch (err) {
        console.error('Erro ao salvar nota referenciada:', err)
        const mensagem = err?.response?.data?.message || err?.message || 'Erro ao salvar nota referenciada'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      }
    },

    async excluir(item) {
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `Deseja realmente excluir a nota referenciada com chave ${item.TX_NUM_CHAVE_ACESSO_NFE}?`,
        {
          title: 'Confirmar Exclusão',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não'
        }
      )

      if (!confirmado) return

      try {
        await this.$http.post(`/api/protected/notaFiscal/referenciada/delete/${item.ID}`)
        
        this.$bvToast.toast('Nota referenciada excluída com sucesso!', { variant: 'success', solid: true })
        await this.carregarReferenciadas()

      } catch (err) {
        console.error('Erro ao excluir nota referenciada:', err)
        const mensagem = err?.response?.data?.message || err?.message || 'Erro ao excluir nota referenciada'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      }
    },

    limparForm() {
      this.form = {
        ID: null,
        ID_NFE: null,
        TX_NUM_CHAVE_ACESSO_NFE: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaNfeReferenciada.vue